import { useCallback } from 'react';

const visuallyHiddenAnnouncementElementId = 'visually-hidden-announcement';
const visuallyHiddenAnnouncementElement = document.getElementById(visuallyHiddenAnnouncementElementId);

/**
 * Custom hook for updating a visually hidden announcement to be announced by a screen reader
 *
 * @returns setVisuallyHiddenAnnouncement - the function that updates the visually hidden announcement
 */
export const useVisuallyHiddenAnnouncement = () => {
	const setVisuallyHiddenAnnouncement = useCallback((announcement: string) => {
		if (visuallyHiddenAnnouncementElement === null) {
			console.warn('No visually hidden announcement element was found.');
			return;
		}

		while (visuallyHiddenAnnouncementElement.firstChild) {
			visuallyHiddenAnnouncementElement.firstChild.remove();
		}

		const visuallyHiddenAnnouncementTextElement = document.createElement('p');
		visuallyHiddenAnnouncementTextElement.textContent = announcement;

		visuallyHiddenAnnouncementElement.appendChild(visuallyHiddenAnnouncementTextElement);

		setTimeout(() => {
			while (visuallyHiddenAnnouncementElement.firstChild) {
				visuallyHiddenAnnouncementElement.firstChild.remove();
			}
		}, 3000);
	}, []);

	return { setVisuallyHiddenAnnouncement };
};
